import script from "./UpdateTienda.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateTienda.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__